import axios from 'axios'
import qs from 'qs'
import Vue from 'vue'
import crypto from './../crypto/cryptoencrypt'

const instanct = axios.create({
    baseURL: 'https://culture.aqitai.com/',
    timeout: 100000,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    },
    transformRequest: [data => qs.stringify(data)]
})

instanct.interceptors.request.use((req) => {

    req.headers.Authorization = 'Bearer ' + ((localStorage.token) ? (localStorage.token) : '')
    if(req.method=='get'){
        if(req.params){
            req.params.apiterminal = 'Aqt_20230517ApiWeb'
            req.params.lang = localStorage.getItem('lang')
            req.params.terminal = 2
        }else {
            let keyVal ={
                apiterminal:'Aqt_20230517ApiWeb',
                lang:localStorage.getItem('lang'),
                terminal:2
            }
            Vue.prototype.$set(req,'params',keyVal)
        }
        req.params = crypto.set(req.params,'qwsdefghyjygrfed')

    }else if(req.method=='post'){
        if(req.data){
            req.data.apiterminal = 'Aqt_20230517ApiWeb'
            req.data.lang = localStorage.getItem('lang')
            req.data.terminal = 2
        }else {
            let keyVal ={
                apiterminal:'Aqt_20230517ApiWeb',
                lang:localStorage.getItem('lang'),
                terminal:2
            }
            Vue.prototype.$set(req,'data',keyVal)
        }
        req.data = crypto.set(req.data,'qwsdefghyjygrfed')
    }
    return req

}, error => {
    return Promise.reject(error)
})


instanct.interceptors.response.use((res) => {
    let mainData = Object.assign({}, res.data)
    if (mainData.code === 200) {
        let nns = crypto.get(mainData.data,'aqitaibookwebasd')
        let resdata = Object.assign({}, nns)
        if (resdata.current_page) {
            delete resdata.data
        }
        return {
            data: resdata.current_page ? nns.data : nns,
            code: mainData.code,
            message: mainData.message,
            pages: resdata.current_page ? resdata : null
        }
    } else {
        return handleErr(mainData)
    }
}, res => {
    if (res.response.status === 401) {
        localStorage.clear()
        // sessionStorage.clear()
        Vm.$store.state.layout.tabList = '[]'
        Vm.$router.push({path:'/login',query:{lib_type:sessionStorage.getItem('gcm')}})
        document.title = ''
    } else {
        if (!res.response) {
            handleErr({
                code: '请求无响应！',
                message: res.config.url
            })
            return false
        }
    }

    return Promise.reject(res)
})

function handleErr(data) {
    if (data.code == 403) {
        Vm.$Notice.error({
            title: '登录超时',
            desc: '请重新登录'
        })
        setTimeout(() => {
            localStorage.clear()
            Vm.$router.push({path:'/login',query:{lib_type:sessionStorage.getItem('gcm')}})
            document.title = ''
        }, 1000)
        return false
    } else if(data.code == 300){
        Vm.$Message.error(data.message.mn)
    }else {
        Vm.$Message.error(data.message)
    }
}

export default instanct
